module.exports = __webpack_public_path__ + "img/copy.2700a3fc.svg";